<template lang='pug' src='./blog-template.pug'></template>
<script>
export default {
  name: 'BlogTemplate',
  computed: {
    blog () {
      const id = this.$route.params.blogID
      return this.$store.state.blog.filter(blog => blog.slug === id)[0]
    }
  },
  methods: {
    redirectToBlogs () {
      this.$router.push('/blog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// blog-template.vue?c52eacb6